






























































































































































import { Component, Vue, ProvideReactive } from "vue-property-decorator";
import { Slider, Badge, Toast, ActionSheet, Image as VanImage } from "vant";
import "videojs-contrib-hls";
import DownloadHeader from "./components/Header.vue";
import Comment from "./components/Comment.vue";
import LiveHeader from "./components/LiveHeader.vue";
import native from "@/common/Native";
import request from "@/api";
import req from "@/api/portrait";
import AppPrompt from "@/components/AppPrompt.vue";
import {
  IClassify,
  IFloating,
  IGetDetail,
  ILiveInfo,
  IReplyItem,
  IShareInfo
} from "@/api/types";
import { isFunction } from "@/common/is";
import { Deprecated } from "@/common/decorator";
import {
  recordCount,
  recordTime,
  recordVideo,
  removRecordTime,
  removRecordVideo
} from "@/api/dataCollect";

@Component({
  components: {
    DownloadHeader,
    LiveHeader,
    Comment,
    Slider,
    Badge,
    ActionSheet,
    VanImage,
    AppPrompt
  }
})
export default class Living extends Vue {
  // 直播间详情
  @ProvideReactive("liveDetail")
  liveDetail: IGetDetail["data"] = {} as IGetDetail["data"];
  appId: number | null = null;
  // 直播间轮询信息
  @ProvideReactive("liveInfo")
  liveInfo: ILiveInfo = {
    replyList: [] as IReplyItem[],
    classifyList: [] as IClassify[]
  } as ILiveInfo;
  // 直播实时更新时常
  @Deprecated
  vDuration = 0;
  // 缓冲进度
  @Deprecated
  vProgress = 0;
  // videojs实例
  vPlayer: videojs.VideoJsPlayer | null = null;
  // 底部操作区高度
  footerHeight = 0;
  // 播放暂停状态
  isPause = false;
  // videojs选项
  videoOptions: videojs.VideoJsPlayerOptions = {
    controls: false,
    autoplay: true,
    poster: require("../../assets/poster.jpeg")
  };
  // 分页信息
  page: Partial<{ lastReplyId: string; classifyId: string }> = {};
  // 悬浮信息
  floatInfo: IFloating = {} as IFloating;
  // 显示浮窗
  floatShow = true;
  // 显示悬浮列表
  showFloatList = false;
  // TODO: 轮询是否已经启动,后面改成装饰器实现@once
  isExcute = false;
  /** 顶部打开app */
  shareInfo: IShareInfo | null = null;
  isOpenApp = false;
  get isM3u8() {
    return (
      this.liveDetail?.bannerVideo?.endsWith("m3u") ||
      this.liveDetail?.bannerVideo?.endsWith("m3u8")
    );
  }

  beforeDestroy() {
    removRecordTime();
    removRecordVideo();
  }
  mounted() {
    const linkView = document.getElementById("linkView") as HTMLDivElement;
    linkView.style.height = "100vh";
    /** 忽略样式 竖版直播目前写法不能适配pc */
    const html = document.getElementsByTagName("html")[0] as HTMLElement;
    html.style.maxWidth = "unset";
    html.style.margin = "unset";
    const body = document.getElementsByTagName("body")[0] as HTMLElement;
    body.style.maxWidth = "unset";
    body.style.margin = "unset";
    this.isOpenApp = !native.isOpenInApp();
    document.title = "新闻直播";
    // document.addEventListener(
    //   "WeixinJSBridgeReady",
    //   () => {
    //     (document.querySelector("#video-live") as HTMLVideoElement).play();
    //     alert("播放！");
    //   },
    //   false
    // );
    if (!native.isOpenInApp()) {
      this.addViewCount();
    }
    this.footerHeight = (this.$refs.footer as HTMLElement).offsetHeight;
    this.getLiveDetail();
    this.getFloatList();
    this.getLiveShareInfo();
    this.solveKeyboardSqueezeScreen();
  }
  close() {
    const liveHeader = document.getElementsByClassName(
      "live-header"
    )[0] as HTMLDivElement;
    liveHeader.style.top = "0.2rem";
  }
  /** 端外增加浏览量 */
  addViewCount() {
    // request
    //   .getCount(this.$route.query.id as string, process.env.VUE_APP_COUNT_API)
    //   .then(() => {});
    request.getCount().then(() => {});
  }

  // 获取直播间基本详情
  async getLiveDetail() {
    req
      .getLiveDetail(this.$route.query.id as string)
      .then(res => {
        if (res.code === 0) {
          this.liveDetail = res.data;
          recordCount({ news: this.liveDetail, sourceType: "news" });
          recordTime({ news: this.liveDetail, sourceType: "news" });
          res.data.bannerImg && (this.videoOptions.poster = res.data.bannerImg);
          // this.liveDetail.bannerVideo =
          //   "https://imagecdn.cqliving.com/livevideo/jlp/1624330290724109/m3u8/tll166j.m3u8";
          this.$nextTick(() => {
            this.initVideo();
          });
          this.$store.commit("SET_STATE", {
            detail: res.data,
            appId: res.data.appId
          });
          this.appId = res.data.appId;
          this.getAppConfig();
          this.getLiveInfo();
          this.getShareInfo();
        } else {
          Toast.fail(res.message);
        }
      })
      .catch(() => {
        Toast.fail("获取直播间信息失败");
      });
  }

  /** 获取顶部唤醒APP信息 */
  async getShareInfo(data?: IShareInfo) {
    if (data) {
      this.shareInfo = data;
      this.$store.commit("SET_STATE", {
        downloadUrl: data.downloadUrl
      });
    } else {
      const result = await request.getShareInfo();
      if (result.code === 0) {
        this.shareInfo = result.data;
        this.$store.commit("SET_STATE", {
          downloadUrl: result.data.downloadUrl
        });
      }
    }
  }
  async getAppConfig() {
    const result = await request.getAppConfig();
    if (result) {
      for (let i = 0; i < result.length; i++) {
        if (result[i].appId == this.appId) {
          const video = document.querySelector("video") as HTMLVideoElement;
          if (video) {
            video.muted = Boolean(result[i].appConfig.liveMute ?? 0);
          }
          this.$store.commit("SET_STATE", {
            hideDetailViewCount: result[i].appConfig.hideDetailViewCount
          });
          break;
        }
      }
    }
  }

  // 轮训用信息
  async getLiveInfo() {
    if (!this.liveDetail.appId) return;
    req
      .getLiveInfo({
        appId: this.liveDetail.appId,
        sourceType: this.liveDetail.sourceType || "1",
        sourceId: this.$route.query.id as string,
        ...this.page
      })
      .then(res => {
        if (res.code === 0) {
          if (!res.data) return;
          const frequency = res.data.autoRefreshFrequency * 1000;
          Object.keys(res.data).forEach(key => {
            if (!["replyList", "classifyList"].includes(key)) {
              Object.assign(this.liveInfo, {
                [key]: res.data[key as keyof ILiveInfo]
              });
            }
          });
          this.$forceUpdate();
          if (res.data.replyList.length) {
            this.liveInfo.replyList.push(...res.data.replyList);
            this.page.lastReplyId = res.data.replyList[0].id; //res.data.replyList.lastChild.id;
          }
          if (res.data.classifyList.length) {
            console.warn(`删除前${~~((frequency || 8000) / 3000)}项`);
            // 删除已经展示过的，根据轮询时间/轮播单个item展示时间获取
            this.liveInfo.classifyList.splice(
              0,
              ~~((frequency || 8000) / 3000)
            );
            this.liveInfo.classifyList.push(...res.data.classifyList);
            this.page.classifyId = res.data.classifyList[0].id;
          }

          !this.isExcute &&
            this.doPolling(this.getLiveInfo, {
              immediate: false,
              wait: frequency || 8000
            });
          this.isExcute = true;
        }
      });
  }

  // 微信分享
  async getLiveShareInfo() {
    if (native.isOpenInApp()) {
      const result = await request.liveShare(this.$route.query.id as string);
      native.setShareConfig({
        id: this.$route.query.id + "",
        title: result.data.shareTitle,
        content: result.data.synopsis,
        icon: result.data.shareImgUrl,
        url: result.data.shareUrl,
        sourceType: result.data.sourceType + ""
      });
    }
  }

  // 轮询函数
  doPolling(
    cb: () => void,
    {
      immediate,
      wait = 8000,
      stop
    }: {
      immediate?: boolean;
      wait?: number;
      stop?: (timer: number) => unknown;
    },
    timer?: number
  ) {
    if (!timer && immediate) {
      isFunction(cb) && cb();
    }
    timer = setTimeout(() => {
      isFunction(cb) && cb();
      this.doPolling(cb, { immediate, wait, stop }, timer);
    }, wait);

    isFunction(stop) && stop(timer);
  }

  // 浮窗列表
  getFloatList() {
    req.getFloatList(this.$route.query.id as string).then(res => {
      if (res.code === 0) {
        this.floatInfo = res.data || { adverInfoList: [], groupIcon: "" };
      } else {
        Toast.fail(res.message);
      }
    });
  }

  // 点击浮窗
  floatClick() {
    if (this.floatInfo.adverInfoList.length > 1) {
      this.showFloatList = true;
    } else {
      location.href = this.floatInfo.adverInfoList[0].linkUrl;
    }
  }

  // 时间轴改变
  onChange(targetTime: number) {
    if (this.vDuration === 0 || !this.vPlayer) return;
    this.vPlayer.currentTime((targetTime / 100) * this.vDuration);
  }

  // 发送评论 用户发送后跳转app下载链接
  onCommentSend() {
    location.href = `http://www.cqliving.com/install/index.html?id=${this.$store.state.appId}`;
  }

  // 点击播放
  onPlay() {
    !this.isPause ? this.vPlayer?.pause() : this.vPlayer?.play();
    setTimeout(() => {
      this.isPause = !this.isPause;
    }, 150);
  }

  // 安卓监听键盘事件 解决窗口挤压问题
  solveKeyboardSqueezeScreen() {
    setTimeout(() => {
      const vw = window.innerWidth,
        vh = window.innerHeight,
        viewport = document.querySelector("meta[name=viewport]")!;

      viewport.setAttribute(
        "content",
        "height=" + vh + "px, width=" + vw + "px, initial-scale=1.0"
      );
    });
  }

  // 初始化播放器
  initVideo() {
    this.isPause = true;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    this.vPlayer = this.$video("video-live", this.videoOptions, () => {
      if (!this.vPlayer) return;
      // 进度条更新
      this.vPlayer.on("timeupdate", function(this: videojs.VideoJsPlayer) {
        _this.isPause = false;
        const currentTime = this.currentTime(),
          duration = this.duration();
        _this.$nextTick(() => {
          // m3u8 即hls，分段直播流，时长会不断更新
          _this.vDuration = duration;
          _this.vProgress = (currentTime / duration) * 100;
        });
      });
      // 结束
      this.vPlayer.on("ended", function(this: videojs.VideoJsPlayer) {
        _this.isPause = true;
      });
    });
    setTimeout(() => {
      recordVideo({
        news: this.liveDetail,
        sourceType: "news",
        ElVideoName: "#video-live"
      });
    }, 100);
  }

  // 筛选页面考虑到ios上用户体验（避免页面栈中大于1底部出现返回bar） 改为以全屏组件的形式存在
  // 这里是解决安卓机在筛选页面直接通过物理按键返回导致页面直接关闭问题
  // 竖屏直播又没设计筛选了 所以这个暂时屏蔽
  @Deprecated
  preventBack() {
    history.pushState(null, "", document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, "", document.URL);
    });
  }

  deactivated() {
    this.onPlay();
  }
}
